import { yogaExchange } from "@graphql-yoga/urql-exchange";
import { devtoolsExchange } from "@urql/devtools";
import { fetchExchange, mapExchange } from "@urql/vue";
import { asyncHeaderExchange } from "urql-exchange-async-headers";
import { auth } from "@/stores/auth.store";
import { Auth } from "@/auth/auth.service";
import { merge, some } from "lodash";
import { toast } from "vue-sonner";
import { useAppStatusStore } from "@/stores/appStatus.store";
import cacheExchange from "./CacheExchange";

// Order of exchanges matters
export function createExchanges() {
  const { setServerMaintenance } = useAppStatusStore();
  return [
    devtoolsExchange, // gets removed for production
    cacheExchange,
    mapExchange({
      onError(error, _operation) {
        for (const graphQLError of error.graphQLErrors) {
          // unexpected errors without a code
          if (auth.account && !graphQLError.extensions?.code) {
            const originalError = error.graphQLErrors[0]?.extensions
              .originalError as
              | {
                  [message: string]: string;
                }
              | undefined;
            toast.error(
              `Unexpected error: \n ${originalError?.message ?? error.message}`,
              { duration: Infinity },
            );
          }
        }
        setServerMaintenance(
          some(
            error.graphQLErrors,
            (e) => e.extensions?.code === "SERVER_MAINTENANCE",
          ),
        );
      },
    }),
    asyncHeaderExchange(async (operation) => {
      const headers = {};
      // A teardown waiting on the token can land after its replacement query and cancel it.
      if (auth.account && operation.kind !== "teardown") {
        const token = await Auth.getToken();
        merge(headers, {
          authorization: `Bearer ${token}`,
          "x-graphql-yoga-csrf": "true",
        });
      }
      if (import.meta.env.VITE_APIM_KEY) {
        merge(headers, {
          "Ocp-Apim-Subscription-Key": import.meta.env.VITE_APIM_KEY,
        });
      }
      if (sessionStorage.getItem("appDate")) {
        merge(headers, {
          "x-session-app-date": sessionStorage.getItem("appDate"),
        });
      }
      return headers;
    }),
    fetchExchange,
    yogaExchange(),
  ];
}
